import { Texture } from 'pixi.js';

export const TILE_SIZE = 24;
export const TILESET_COLS = 16;
export const TILESET_ROWS = 8;
export const TILES_PER_SET = TILESET_COLS * TILESET_ROWS; // 128

/**
 * A processed tileset: 128 tile textures (24x24) plus per-tile collision masks
 * derived from pixel alpha (after magenta->transparent processing).
 */
export class Tileset {
  readonly frames: Texture[] = []; // length 128
  // masks[tileIndex] = Uint8Array(24*24): 1 = solid pixel
  readonly masks: Uint8Array[] = [];

  constructor(
    readonly base: Texture,
    frames: Texture[],
    masks: Uint8Array[],
  ) {
    this.frames = frames;
    this.masks = masks;
  }

  /** Is pixel (lx,ly) within tile `index` solid? lx,ly in 0..23. */
  isSolidPixel(index: number, lx: number, ly: number): boolean {
    if (index < 0 || index >= TILES_PER_SET) return false;
    if (lx < 0 || lx >= TILE_SIZE || ly < 0 || ly >= TILE_SIZE) return false;
    return this.masks[index][ly * TILE_SIZE + lx] !== 0;
  }
}
